import React, { useEffect, useState } from 'react'
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import styles from './Card.module.scss'
import classNames from 'classnames';
import i18n from '../../../../lib/i18n';
import { FaChevronLeft, FaChevronRight, FaDownload, FaMousePointer } from "react-icons/fa";

function Card({
  card,
  prevId,
  nextId,
  current,
  count,
  category,
  hideAction,
  onOpen = () => { },
  setCurrent = () => { },
  downloadAnki = () => { }
}) {
  const [active, setActive] = useState(false)
  useEffect(() => {
    setActive(false)
  }, [card])

  const open = () => {
    setActive(!active)
  }

  return (
    <div className={classNames(styles['FlashCard'], { [styles.inList]: hideAction })}>
      <div className={styles["block-question"]}>
        <div className={styles["flip-card"]}>
          <div className={classNames(styles["flip-card-inner"], { [styles.active]: active })}>
            <div className={styles["flip-card-front"]} onClick={open}>
              <div className={classNames(styles["content-block"], { [styles['has-image']]: !!card.question_img })}>
                {card.question_img && <div className={styles['image']}>
                  <PhotoProvider>
                    <PhotoView src={card.question_img}>
                      <img onClick={(e) => {
                        e.stopPropagation()
                      }} src={card.question_img} alt={card.question_img_alt} />
                    </PhotoView>
                  </PhotoProvider>
                  {Boolean(card.question_img_alt) && <div className={styles['image_alt']}>{card.question_img_alt}</div>}
                </div>}
                <div className={styles["block-text"]}>
                  <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: card.question }} />
                </div>
              </div>
              <div className={styles["block-show-answer"]}>
                <FaMousePointer /> <span>{i18n('Click for answer')}</span>
              </div>
            </div>
            <div className={styles["flip-card-back"]}>
              <div className={classNames(styles["content-block"], { [styles['has-image']]: !!card.answer_img })}>
                {card.answer_img && <div className={styles['image']}>
                  <PhotoProvider>
                    <PhotoView src={card.answer_img}>
                      <img onClick={(e) => {
                        e.stopPropagation()
                      }} src={card.answer_img} alt={card.answer_img_alt} />
                    </PhotoView>
                  </PhotoProvider>
                  {Boolean(card.answer_img_alt) && <div className={styles['image_alt']}>{card.answer_img_alt}</div>}
                </div>}
                <div className={styles["block-text"]}>
                  <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: card.answer }} />
                </div>
              </div>

              {hideAction && <div className={styles["block-show-answer"]} style={{ cursor: 'pointer' }} onClick={() => setActive(false)}>
                <FaMousePointer /> <span>{i18n('Click for question')}</span>
              </div>}
              {!hideAction && <div className={styles["block-show-answer"]}>
                <button className="btn btn-danger" onClick={() => {
                  if (nextId > -1) {
                    setCurrent(nextId)
                  } else {
                    setActive(false)
                    onOpen()
                  }
                }}>{i18n('Don\'t Know')}</button>
                <button className="btn btn-warning" onClick={() => {
                  if (nextId > -1) {
                    setCurrent(nextId)
                  } else {
                    setActive(false)
                    onOpen()
                  }
                }}>{i18n('Ok')}</button>
                <button className="btn btn-success" onClick={() => {
                  if (nextId > -1) {
                    setCurrent(nextId)
                  } else {
                    setActive(false)
                    onOpen()
                  }
                }}>{i18n('Nailed It')}</button>
              </div>}
            </div>
          </div>
        </div>
      </div>
      {!hideAction && <div className={styles["action-card"]}>
        <div>
          <div className={classNames(styles['fa-chevron-left'], { [styles.disabled]: prevId == -1 })} onClick={() => prevId > -1 ? setCurrent(prevId) : null}>
            <FaChevronLeft size={16} />
          </div>

          {current}/{count}
          <div className={classNames(styles['fa-chevron-right'], { [styles.disabled]: nextId == -1 })} onClick={() => nextId > -1 ? setCurrent(nextId) : null}>
            <FaChevronRight size={16} />
          </div>
        </div>
        <div style={{ position: 'absolute', right: 0, zIndex: 2 }}>
          {true && <div style={{ cursor: 'pointer' }} onClick={(e) => {
            downloadAnki();
          }} className='download_anki'><FaDownload /> {i18n('txtDownloadAnki')}</div>}
        </div>
      </div>}
    </div>
  )
}


export default Card